import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "RequestError", "$identifier$ - $error_message$", config.defaultMessageId, true)